
<div class="tw-min-h-full tw-flex tw-flex-col tw-justify-between">
    <div class="sidenav-itemlist tw-flex tw-flex-col tw-items-start">
        <section class="tw-w-11/12 tw-mx-auto">
            @if(!isConnectionOffline()) {
                @if(enabledModules['dashboard']) {
                    <button mat-button class="mat-button-sidebar" [ngClass]="{'nav-button-active':isCurrentRoute('dashboard')}" (click)="goTo.emit('new.dashboard')">
                        <mat-icon alt="">store</mat-icon>
                        <span class="sidebar-text" translate>SIDENAV.MODULES.DASHBOARD</span>
                    </button>
                }
                @if(enabledModules['bookings']) {
                    <button mat-button class="mat-button-sidebar" [ngClass]="{'nav-button-active':isCurrentRoute('bookings')}" (click)="goTo.emit(showNewFeature('bookings') ? 'new.bookings' : 'bookings')">
                        <mat-icon>event</mat-icon>
                        <span class="sidebar-text" translate>SIDENAV.MODULES.BOOKINGS</span>
                    </button>
                }
                @if(enabledModules['kiosk']) {
                    <button mat-button class="mat-button-sidebar" [ngClass]="{'nav-button-active':isCurrentRoute('kiosk')}" (click)="goToKiosk()">
                        <mat-icon alt="">accessibility_new</mat-icon>
                        <span class="sidebar-text" translate>SIDENAV.MODULES.KIOSK</span>
                    </button>
                }
            }
            @if(enabledModules['tables']) {
                <button mat-button class="mat-button-sidebar" [ngClass]="{'nav-button-active':isCurrentRoute('tables')}" (click)="goTo.emit('new.tables')">
                    <mat-icon>view_quilt</mat-icon>
                    <span class="sidebar-text" translate>SIDENAV.MODULES.TABLES</span>
                </button>
            }
            @if(enabledModules['orders']) {
                <button mat-button class="mat-button-sidebar" [ngClass]="{'nav-button-active':isCurrentRoute('delivery-take-away')}" (click)="goTo.emit('new.delivery-take-away')">
                    <mat-icon>shopping_bag</mat-icon>
                    <span class="sidebar-text" translate>SIDENAV.FIXED.TAKE_AWAY</span>
                </button>
            }
            @if(enabledModules['cashregister']) {
                <button mat-button class="mat-button-sidebar full-size" [ngClass]="{'nav-button-active':isCurrentRoute('cashregister')}" (click)="goTo.emit('new.cashregister.content.showcase')">
                    <mat-icon>keyboard</mat-icon>
                    <div class="tw-flex tw-items-center tw-justify-between tw-w-full">
                        <span class="sidebar-text" translate>SIDENAV.MODULES.CASHREGISTER</span>
                        @if(externalSalesCount()) {
                            <div class="sidenav-sales-badge">{{externalSalesCount()}}</div>
                        }
                    </div>
                </button>
            }
            @if(!isConnectionOffline()) {
                @if(enabledModules['history']) {
                    <button #history mat-button class="mat-button-sidebar" (click)="toggleSubmenu($any(history),'history')">
                        <mat-icon>settings_backup_restore</mat-icon>
                        <span class="sidebar-text" translate>SIDENAV.MODULES.HISTORY_MENU</span>
                    </button>
                    @if(submenus.history) {
                        <div class="mat-sub-button-sidebar tw-flex tw-flex-col tw-items-start">
                            <button mat-button class="mat-button-sidebar" [ngClass]="{'nav-button-active':isCurrentRoute('new.history.module')}"
                                    (click)="goTo.emit('new.history.module.sales')">
                                <mat-icon>receipt</mat-icon>
                                <span class="sidebar-text" translate>SIDENAV.MODULES.HISTORY.SALES</span>
                            </button>
                            @if(country === 'IT') {
                                <button mat-button class="mat-button-sidebar"
                                    (click)="goTo.emit(showNewFeature('history.e_invoices') ? 'new.history.module.e_invoices' : 'history.e_invoices')">
                                    <mat-icon>file_copy</mat-icon>
                                    <span class="sidebar-text" translate>SIDENAV.MODULES.HISTORY.EINVOICES</span>
                                </button>
                            }
                            <button mat-button class="mat-button-sidebar" [ngClass]="{'nav-button-active':isCurrentRoute('new.history.cash-movements')}" (click)="goTo.emit('new.history.cash-movements')">
                                <mat-icon>swap_vertical_circle</mat-icon>
                                <span class="sidebar-text" translate>SIDENAV.MODULES.HISTORY.CASH_MOVEMENTS</span>
                            </button>
                            <button mat-button class="mat-button-sidebar" [ngClass]="{'nav-button-active':isCurrentRoute('new.history.products-deleted')}" (click)="goTo.emit('new.history.products-deleted')">
                                <mat-icon>playlist_remove</mat-icon>
                                <span class="sidebar-text" translate>SIDENAV.MODULES.HISTORY.PRODUCTS_DELETED</span>
                            </button>
                        </div>
                    }
                }
                @if(enabledModules['stock'] || enabledModules['suppliers']) {
                    <button #warehouse mat-button class="mat-button-sidebar" (click)="toggleSubmenu($any(warehouse),'stock')">
                        <mat-icon>widgets</mat-icon>
                        <span class="sidebar-text" translate>SIDENAV.MODULES.WAREHOUSE_MENU</span>
                    </button>
                    @if(submenus.stock) {
                        <div class="mat-sub-button-sidebar tw-flex tw-flex-col tw-items-start">
                            @if(enabledModules['stock']) {
                                <button mat-button class="mat-button-sidebar" [ngClass]="{'nav-button-active':isCurrentRoute('stock.management')}" (click)="goTo.emit(showNewFeature('stock.management') ? 'new.stock.management' : 'stock.management')">
                                    <mat-icon>content_paste</mat-icon>
                                    <span class="sidebar-text" translate>SIDENAV.MODULES.WAREHOUSE.STOCK</span>
                                </button>
                                <button mat-button class="mat-button-sidebar" [ngClass]="{'nav-button-active':isCurrentRoute('stock.movements')}" (click)="goTo.emit(showNewFeature('stock.movements') ? 'new.stock.movements' : 'stock.movements')">
                                    <mat-icon>import_export</mat-icon>
                                    <span class="sidebar-text" translate>SIDENAV.MODULES.WAREHOUSE.MOVEMENTS</span>
                                </button>
                            }
                            @if(enabledModules['suppliers']) {
                                <button mat-button class="mat-button-sidebar" [ngClass]="{'nav-button-active':isCurrentRoute('suppliers')}"
                                        (click)="goTo.emit('new.suppliers')">
                                    <mat-icon>local_shipping</mat-icon>
                                    <span class="sidebar-text" translate>SIDENAV.MODULES.WAREHOUSE.SUPPLIERS</span>
                                </button>
                            }
                            @if(country === 'IT') {
                                <button mat-button class="mat-button-sidebar" [ngClass]="{'nav-button-active':isCurrentRoute('history.e_invoices_passive')}" (click)="openPassiveInvoicePortal()">
                                    <mat-icon>receipt</mat-icon>
                                    <span class="sidebar-text" translate>SIDENAV.MODULES.WAREHOUSE.PASSIVE_EINVOICES</span>
                                </button>
                            }
                        </div>
                    }
                }
                @if(enabledModules['items']) {
                    <button mat-button class="mat-button-sidebar" [ngClass]="{'nav-button-active':isCurrentRoute('items')}" (click)="goTo.emit(showNewFeature('items') ? 'new.items' : 'items.showcase')">
                        <mat-icon>layers</mat-icon>
                        <span class="sidebar-text" translate>SIDENAV.MODULES.ITEMS</span>
                    </button>
                }
                @if(enabledModules['customers']) {
                    <button mat-button class="mat-button-sidebar" [ngClass]="{'nav-button-active':isCurrentRoute('customers')}"
                            (click)="goTo.emit('new.customers.showcase')">
                        <mat-icon>group</mat-icon>
                        <span class="sidebar-text" translate>SIDENAV.MODULES.CUSTOMERS</span>
                    </button>
                }
                <button #marketing mat-button class="mat-button-sidebar"(click)="toggleSubmenu($any(marketing),'marketing')">
                    <mat-icon>rocket_launch</mat-icon>
                    <span class="sidebar-text" translate>SIDENAV.MODULES.MARKETING_MENU</span>
                </button>
                @if(submenus.marketing) {
                    <div class="mat-sub-button-sidebar tw-flex tw-flex-col tw-items-start">
                        <button mat-button class="mat-button-sidebar" [ngClass]="{'nav-button-active':isCurrentRoute('fidelity')}" (click)="openPromotedModule('fidelity')">
                            <mat-icon>card_giftcard</mat-icon>
                            <span class="sidebar-text" translate>SIDENAV.MODULES.FIDELITY</span>
                        </button>
                        @if(enabledModules['promotions']) {
                            <button mat-button class="mat-button-sidebar" [ngClass]="{'nav-button-active':isCurrentRoute('promotions')}" (click)="openPromotedModule('promotions')">
                                <mat-icon>stars</mat-icon>
                                <span class="sidebar-text" translate>SIDENAV.MODULES.PROMOTIONS</span>
                            </button>
                        }
                        <button mat-button class="mat-button-sidebar" [ngClass]="{'nav-button-active':isCurrentRoute('giftcard')}" (click)="openPromotedModule('giftcard')">
                            <mat-icon>card_membership</mat-icon>
                            <span class="sidebar-text" translate>SIDENAV.MODULES.GIFTCARD</span>
                        </button>
                    </div>
                }

                <button #settings mat-button class="mat-button-sidebar" (click)="toggleSubmenu($any(settings),'settings')">
                    <mat-icon>settings</mat-icon>
                    <span class="sidebar-text" translate>SIDENAV.MODULES.SETTINGS_MENU</span>
                </button>
                @if(submenus.settings) {
                    <div class="mat-sub-button-sidebar tw-flex tw-flex-col tw-items-start">
                        @if(settingsEnabled) {
                            <button mat-button class="mat-button-sidebar" [ngClass]="{'nav-button-active':isCurrentRoute('settings.hub') || isCurrentRoute('settings.general')}" (click)="goTo.emit(showNewFeature('settings.general') ? 'new.settings.hub' : 'settings.general')">
                                <mat-icon>settings_applications</mat-icon>
                                <span class="sidebar-text" translate>SIDENAV.MODULES.SETTINGS.GENERAL</span>
                            </button>
                            <button mat-button class="mat-button-sidebar" [ngClass]="{'nav-button-active':isCurrentRoute('settings.channels_management')}"
                                (click)="goTo.emit('new.settings.channels_management')">
                                <mat-icon>merge_type</mat-icon>
                                <span class="sidebar-text" translate>SIDENAV.MODULES.SETTINGS.CHANNELS_MANAGEMENT</span>
                            </button>
                            <button mat-button class="mat-button-sidebar" [ngClass]="{'nav-button-active':isCurrentRoute('settings.tickets')}"
                                (click)="goTo.emit('new.settings.tickets')">
                                <mat-icon>confirmation_number</mat-icon>
                                <span class="sidebar-text" translate>SIDENAV.MODULES.SETTINGS.TICKETS</span>
                            </button>
                        }
                        @if(gloryPaymentMethod && showOpenDrawer){
                            <button mat-button class="mat-button-sidebar" (click)="execGloryApp()">
                                <mat-icon>payments</mat-icon>
                                <span class="sidebar-text" translate>SIDENAV.MODULES.SETTINGS.GLORY_SETTINGS</span>
                            </button>
                        }
                        @if(paymentMethodsCashmatic.length > 0){
                            <button mat-button class="mat-button-sidebar" (click)="openCashmaticBackoffice()">
                                <mat-icon>payments</mat-icon>
                                <span class="sidebar-text" translate>Cashmatic</span>
                            </button>
                        }
                        @if(enabledModules['file_importer']) {
                            <button mat-button class="mat-button-sidebar" [ngClass]="{'nav-button-active':isCurrentRoute('file_importer')}" (click)="goTo.emit('new.file_importer.showcase')">
                                <mat-icon>file_upload</mat-icon>
                                <span class="sidebar-text" translate>SIDENAV.MODULES.SETTINGS.FILE_IMPORTER</span>
                            </button>
                        }
                        <button mat-button class="mat-button-sidebar" [ngClass]="{'nav-button-active':isCurrentRoute('file_exporter')}" (click)="goTo.emit('new.file_exporter.showcase')">
                            <mat-icon>file_download</mat-icon>
                            <span class="sidebar-text" translate>SIDENAV.MODULES.SETTINGS.FILE_EXPORTER</span>
                        </button>
                        <button mat-button class="mat-button-sidebar" [ngClass]="{'nav-button-active':isCurrentRoute('settings.users_management')}" (click)="goTo.emit('new.settings.users_management')">
                            <mat-icon>people</mat-icon>
                            <span class="sidebar-text" translate>SIDENAV.MODULES.SETTINGS.USERS_MANAGEMENT</span>
                        </button>
                        @if(enabledModules['printers']) {
                            <button mat-button class="mat-button-sidebar" [ngClass]="{'nav-button-active':isCurrentRoute('printers')}" (click)="goTo.emit(showNewFeature('settings.printers') ? 'new.settings.printers' : 'printers')">
                                <mat-icon>print</mat-icon>
                                <span class="sidebar-text" translate>SIDENAV.MODULES.SETTINGS.PRINTERS</span>
                            </button>
                        }
                        @if(cashlogyPaymentMethod) {
                            <button mat-button class="mat-button-sidebar" (click)="openCashlogyBackoffice()">
                                <mat-icon>local_atm</mat-icon>
                                <span class="sidebar-text" translate>SIDENAV.MODULES.SETTINGS.CASHLOGY</span>
                            </button>
                        }
                        @if(cimaPaymentMethod) {
                            <button mat-button class="mat-button-sidebar" (click)="openCimaBackoffice()">
                                <mat-icon>local_atm</mat-icon>
                                <span class="sidebar-text" translate>SIDENAV.MODULES.SETTINGS.CIMA</span>
                            </button>
                        }
                        @if(vnePaymentMethod) {
                            <button mat-button class="mat-button-sidebar" (click)="openVneBackoffice()">
                                <mat-icon>payments</mat-icon>
                                <span class="sidebar-text" translate>SIDENAV.MODULES.SETTINGS.VNE</span>
                            </button>
                        }
                        @if(settingsEnabled) {
                            @if(enabledModules['kiosk']) {
                                <button mat-button class="mat-button-sidebar" [ngClass]="{'nav-button-active':isCurrentRoute('settings.kiosk')}" (click)="goTo.emit(showNewFeature('settings.kiosk') ? 'new.settings.kiosk' : 'settings.kiosk')">
                                    <mat-icon>aod</mat-icon>
                                    <span class="sidebar-text" translate>SIDENAV.MODULES.SETTINGS.KIOSK_SETTINGS</span>
                                </button>
                            }
                            <button mat-button class="mat-button-sidebar" [ngClass]="{'nav-button-active':isCurrentRoute('settings.shifts')}" (click)="goTo.emit('new.settings.shifts')">
                                <mat-icon>date_range</mat-icon>
                                <span class="sidebar-text" translate>SIDENAV.MODULES.SETTINGS.SHIFTS</span>
                            </button>
                            <button mat-button class="mat-button-sidebar" [ngClass]="{'nav-button-active':isCurrentRoute('settings.label_panel')}" (click)="goTo.emit('new.settings.label_panel')">
                                <mat-icon>style</mat-icon>
                                <span class="sidebar-text" translate>SIDENAV.MODULES.SETTINGS.LABEL_PANEL</span>
                            </button>
                            <button mat-button class="mat-button-sidebar" [ngClass]="{'nav-button-active':isCurrentRoute('settings.model_document')}" (click)="goTo.emit('new.settings.model_document')">
                                <mat-icon>style</mat-icon>
                                <span class="sidebar-text" translate>SIDENAV.MODULES.SETTINGS.MODEL_DOCUMENT</span>
                            </button>
                            @if(enabledModules['alvolo_menu']) {
                                <button mat-button class="mat-button-sidebar" [ngClass]="{'nav-button-active':isCurrentRoute('settings.alvolo')}" (click)="goTo.emit('new.settings.alvolo')">
                                    <mat-icon svgIcon="{{ themeModeService.isDarkTheme() ? 'alvolo-dark' : 'alvolo' }}"></mat-icon>
                                    <span class="sidebar-text" translate>SIDENAV.MODULES.SETTINGS.ALVOLO</span>
                                </button>
                            }
                        }
                    </div>
                }
                <mat-divider class="tw-w-full"/>
                @if(showSupport()) {
                    <button mat-button class="mat-button-sidebar" (click)="openSupport()">
                        <mat-icon>help</mat-icon>
                        <span class="sidebar-text after:tw-font-materialIcons after:tw-content-['launch'] after:tw-ml-3 after:tw-text-lg after:tw-align-sub" translate>SIDENAV.HELP_SUPPORT</span>
                    </button>
                }
                @if(isAnalyticsEnabled()) {
                    <button mat-button class="mat-button-sidebar" (click)="openAnalytics()">
                        <mat-icon>show_chart</mat-icon>
                        <span class="sidebar-text after:tw-font-materialIcons after:tw-content-['launch'] after:tw-ml-3 after:tw-text-lg after:tw-align-sub" translate>SIDENAV.ANALYTICS</span>
                    </button>
                }
                @if(showPurchaseInfo()) {
                    <button mat-button class="mat-button-sidebar" (click)="openPurchaseInfo()">
                        <mat-icon>sentiment_satisfied_alt</mat-icon>
                        <span class="sidebar-text after:tw-font-materialIcons after:tw-content-['launch'] after:tw-ml-3 after:tw-text-lg after:tw-align-sub" translate>SIDENAV.PURCHASE_INFO</span>
                    </button>
                }
            }
        </section>
    </div>
</div>

